import * as React from "react";
import { UitkButtonToggleGroup, UitkButtonToggleGroupProps } from "uitk-react-button-toggle";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

export const ButtonToggleGroup: React.FC<UitkButtonToggleGroupProps> = ({ className: customClassName, ...props }) => (
  <UitkLayoutFlex wrap="wrap">
    <UitkLayoutFlexItem>
      <UitkButtonToggleGroup {...props} wrapButtons className={customClassName} />
    </UitkLayoutFlexItem>
  </UitkLayoutFlex>
);

export default ButtonToggleGroup;
